( function( $ ) {
    $( ".trainingen__filter li" ).on('click', function() {
        // remove classes from all
        $( ".trainingen__filter li" ).removeClass( "active" );
        // add class to the one we clicked
        $( this ).addClass( "active" );
    });

    //filter academy page
    $('.tax-filter').on('click', function(event) {

        // Prevent default action - opening tag page
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        // Get tag slug from title attirbute
        var selected_taxonomy = $(this).attr('title');

        // After user click on tag, fade out list of posts
        $('.trainingen__holder .row').fadeOut();

        data = {
            action: 'filter_posts', // function to execute
            afp_nonce: themevars.afp_nonce, // wp_nonce
            taxonomy: selected_taxonomy, // selected tag
            post_id: themevars.post_id
        };

        $.post( themevars.ajaxurl, data, function(response) {

            if( response ) {
                // Display posts on page
                $('.trainingen__holder .row').html( response );
                // Restore div visibility
                $('.trainingen__holder .row').fadeIn();
            };
        });
    });

    // StickyHeader
    if ($('.trainingen__navigatie').length > 0) {
        stickyHeader = function () {
            var stickyOffset = $('.trainingen__navigatie').offset().top;

            $(window).on('scroll', function () {
                var sticky = $('.trainingen__navigatie'),
                    scroll = $(window).scrollTop();

                if (scroll > stickyOffset) {
                    sticky.addClass('trainingen__navigatie__fixed');
                }
                else {
                    sticky.removeClass('trainingen__navigatie__fixed');
                }
            });
        }();
    }

} )( jQuery );
